import { AliasToken } from 'antd/es/theme/internal';
import { windowBreakpoints } from '../../../../../hooks/useDeviceSize';
import { responsiveStyle } from '../../../../../util/helpers';

export const countryPickerStyle = (token?: AliasToken, viewportSize?: windowBreakpoints) => ({
  label: {
    width: '256px',
  },
  flag: {
    width: '32px',
    height: '32px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: '',
  },
  flagPhone: {
    width: '24px',
    height: '24px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: '',
  },
  flagText: {
    size: 40,
    lineHeight: '0px',
    transform: 'rotateZ( 5deg )',
  },
  phoneText: {
    color: 'gray',
  },
});

export default countryPickerStyle;
